import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface Props {
  service?: string;
  message?: string;
  onRetry?: () => void;
}

export const ServiceUnavailable: React.FC<Props> = ({ service, message, onRetry }) => (
  <div className="flex items-center justify-center min-h-[400px] p-8">
    <div className="text-center max-w-md">
      <div className="mx-auto w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-4">
        <AlertTriangle className="h-8 w-8 text-yellow-600" />
      </div>
      <h2 className="text-lg font-semibold text-gray-800 mb-2">
        {service ? `${service} temporairement indisponible` : 'Service temporairement indisponible'}
      </h2>
      <p className="text-sm text-gray-500 mb-4">
        {message || "Le service ne repond pas. Les autres modules restent accessibles via la sidebar."}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm"
        >
          <RefreshCw size={14} />
          Reessayer
        </button>
      )}
    </div>
  </div>
);

export default ServiceUnavailable;
